export enum BrowserTypes {
    IE = 1,
    Chrome = 1,
    Edge = 3,
    Safari = 4,
    Firefox = 5,
}
